/* @meta
layout: room-green
*/
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  setRoomsCleared,
  setModalStatus,
  setGameFinished,
  setSelectedRoom,
  setStartButtonUrl,
} from '../../modules/gameProgress'
import { openQuizModal } from '../../modules/quizzes'

import { withStatechart } from 'react-automata'
import { clickItem, removeItemsForRoom } from '../../modules/itemInteractions'
import { getRoomButtonText } from '../../helpers'
import { connectAudio } from '../../components/AudioProvider'
import Preload from '../../components/Preload'
import RoomPageBase from '../../components/RoomPageBase'
import LivingRoomRoomDesktop from './_LivingRoomRoom.desktop'
import LivingRoomRoomMobile from './_LivingRoomRoom.mobile'
import StyledDesktop from './_StyledDesktop'
import StyledMobile from './_StyledMobile'
import StyledPreloadBar from './_StyledPreloadBar'
import StyledTipTracker from './_StyledTipTracker'
import StyledFooter from './_StyledFooter'

// Preload items
import CharacterKeoniForwardImage from '../../assets/images/character--keoni-forward@3x.png'
import CharacterPluggyForwardImage from '../../assets/images/character--pluggy-forward@3x.png'
import FloorWoodImage from '../../assets/images/floor--wood@3x.png'
import IndicatorArrowDownImage from '../../assets/images/indicator--arrow-down@3x.png'
import ItemACFrame1Image from '../../assets/images/item--ac--f1@3x.png'
import ItemACFrame2Image from '../../assets/images/item--ac--f2@3x.png'
import ItemACFrame3Image from '../../assets/images/item--ac--f3@3x.png'
import ItemACFrame4Image from '../../assets/images/item--ac--f4@3x.png'
import ItemACFrame5Image from '../../assets/images/item--ac--f5@3x.png'
import ItemACFrame6Image from '../../assets/images/item--ac--f6@3x.png'
import ItemACFrame7Image from '../../assets/images/item--ac--f7@3x.png'
import ItemACFrame8Image from '../../assets/images/item--ac--f8@3x.png'
import ItemACFrame9Image from '../../assets/images/item--ac--f9@3x.png'
import ItemBlindsFrame1Image from '../../assets/images/item--blinds--f1@3x.png'
import ItemBlindsFrame2Image from '../../assets/images/item--blinds--f2@3x.png'
import ItemBlindsFrame3Image from '../../assets/images/item--blinds--f3@3x.png'
import ItemBlindsFrame4Image from '../../assets/images/item--blinds--f4@3x.png'
import ItemBlindsFrame5Image from '../../assets/images/item--blinds--f5@3x.png'
import ItemChloeFrame1Image from '../../assets/images/item--chloe--f1@3x.png'
import ItemChloeFrame2Image from '../../assets/images/item--chloe--f2@3x.png'
import ItemChloeFrame3Image from '../../assets/images/item--chloe--f3@3x.png'
import ItemChloeFrame4Image from '../../assets/images/item--chloe--f4@3x.png'
import ItemChloeFrame5Image from '../../assets/images/item--chloe--f5@3x.png'
import ItemChloeFrame6Image from '../../assets/images/item--chloe--f6@3x.png'
import ItemChloeFrame7Image from '../../assets/images/item--chloe--f7@3x.png'
import ItemEntertainmentSystemImage from '../../assets/images/item--entertainment-system@3x.png'
import ItemPlantImage from '../../assets/images/item--plant@3x.png'
import ItemPowerStripImage from '../../assets/images/item--power-strip@3x.png'
import ItemRugImage from '../../assets/images/item--rug@3x.png'
import ItemSofa1Image from '../../assets/images/item--sofa-1@3x.png'
import ItemSofa2Image from '../../assets/images/item--sofa-2@3x.png'
import WallsGreenImage from '../../assets/images/walls--green@3x.png'

const preloadItems = [
  CharacterKeoniForwardImage,
  CharacterPluggyForwardImage,
  FloorWoodImage,
  IndicatorArrowDownImage,
  ItemACFrame1Image,
  ItemACFrame2Image,
  ItemACFrame3Image,
  ItemACFrame4Image,
  ItemACFrame5Image,
  ItemACFrame6Image,
  ItemACFrame7Image,
  ItemACFrame8Image,
  ItemACFrame9Image,
  ItemBlindsFrame1Image,
  ItemBlindsFrame2Image,
  ItemBlindsFrame3Image,
  ItemBlindsFrame4Image,
  ItemBlindsFrame5Image,
  ItemChloeFrame1Image,
  ItemChloeFrame2Image,
  ItemChloeFrame3Image,
  ItemChloeFrame4Image,
  ItemChloeFrame5Image,
  ItemChloeFrame6Image,
  ItemChloeFrame7Image,
  ItemEntertainmentSystemImage,
  ItemPlantImage,
  ItemPowerStripImage,
  ItemRugImage,
  ItemSofa1Image,
  ItemSofa2Image,
  WallsGreenImage,
]

const mapStateToProps = (state) => ({
  firstName: state.player.firstName,
  clickedItems: state.itemInteractions.clickedItems,
  roomsCleared: state.gameProgress.roomsCleared,
  gameFinished: state.gameProgress.gameFinished,
  modalIsActive: state.gameProgress.modalIsActive,
  isOver18: state.player.isOver18,
  clearedQuizRoomIds: state.quizzes.clearedQuizRoomIds,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clickItem,
      removeItemsForRoom,
      setRoomsCleared,
      setGameFinished,
      setModalStatus,
      setSelectedRoom,
      setStartButtonUrl,
      openQuizModal,
    },
    dispatch,
  )

const statechart = {
  initial: 'init',
  states: {
    init: {
      on: {
        NEXT: 'guide',
      },
    },

    guide: {
      on: {
        NEXT: 'items',
        AC: 'ac',
        BLINDS: 'blinds',
        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
        POWER_STRIP: 'powerStrip',
        CHLOE: 'chloe',
      },
    },

    items: {
      on: {
        AC: 'ac',
        BLINDS: 'blinds',
        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
        POWER_STRIP: 'powerStrip',
        CHLOE: 'chloe',
      },
    },

    ac: {
      on: {
        NEXT: 'items',
        AC: 'ac',
        BLINDS: 'blinds',
        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
        POWER_STRIP: 'powerStrip',
        CHLOE: 'chloe',
      },
    },
    blinds: {
      on: {
        NEXT: 'items',
        AC: 'ac',
        BLINDS: 'blinds',
        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
        POWER_STRIP: 'powerStrip',
        CHLOE: 'chloe',
      },
    },
    entertainmentSystem: {
      on: {
        NEXT: 'items',
        AC: 'ac',
        BLINDS: 'blinds',
        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
        POWER_STRIP: 'powerStrip',
        CHLOE: 'chloe',
      },
    },
    powerStrip: {
      on: {
        NEXT: 'items',
        AC: 'ac',
        BLINDS: 'blinds',
        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
        POWER_STRIP: 'powerStrip',
        CHLOE: 'chloe',
      },
    },

    // Easter egg
    chloe: {
      on: {
        NEXT: 'items',
        AC: 'ac',
        BLINDS: 'blinds',
        ENTERTAINMENT_SYSTEM: 'entertainmentSystem',
        POWER_STRIP: 'powerStrip',
        CHLOE: 'chloe',
      },
    },
  },
}

class LivingRoomPage extends RoomPageBase {
  static roomName = 'Living Room'

  static roomId = 'living-room'

  static validItems = ['entertainmentSystem', 'blinds', 'ac', 'powerStrip']

  static tipsCount = 4

  componentDidMount() {
    RoomPageBase.prototype.componentDidMount.bind(this)()
    this.props.removeItemsForRoom(this.constructor.roomId)
  }

  onPreloadLoaded() {
    setTimeout(() => this.props.transition('NEXT'), 1000)
  }

  onItemClick(id) {
    let fullItemId = `${this.constructor.roomId}__${id}`

    const playSound = () => {
      if (!this.props.clickedItems.includes(fullItemId)) {
        this.props.audio.xyl1.play()
      }
    }

    const { machineState } = this.props
    switch (machineState) {
      // case 'guide':
      // case 'itemsLimited':
      //   if (id === 'powerStrip') {
      //     super.onItemClick(id)
      //     if (this.constructor.validItems.includes(id)) playSound()
      //   }
      //   break

      default:
        super.onItemClick(id)
        if (this.constructor.validItems.includes(id)) playSound()
        break
    }
  }

  getPendingHighlightIds() {
    const { machineState } = this.props

    switch (machineState) {
      // case 'init':
      // case 'guide':
      // case 'itemsLimited':
      //   return ['powerStrip']

      default: {
        const clickedItems = this.getClickedItemsForRoom()

        return this.constructor.validItems.filter(
          (item) => !clickedItems.includes(item),
        )
      }
    }
  }

  getSuccessHighlightIds() {
    return this.getClickedItemsForRoom()
  }

  getAnimateIds() {
    const { machineState } = this.props

    switch (machineState) {
      case 'blinds':
        return ['blinds']

      default:
        return []
    }
  }

  shouldBlock() {
    const { machineState } = this.props

    switch (machineState) {
      case 'items':
        return this.clickedAllItems()

      case 'guide':
      case 'ac':
      case 'blinds':
      case 'entertainmentSystem':
      case 'powerStrip':
      case 'chloe':
        return true
    }
  }

  render() {
    const {
      data,
      transition,
      roomsCleared,
      modalIsActive,
      setGameFinished,
      setModalStatus,
      setRoomsCleared,
      gameFinished,
      setSelectedRoom,
      setStartButtonUrl,
      isOver18,
      openQuizModal,
      clearedQuizRoomIds,
    } = this.props
    const pendingHighlightIds = this.getPendingHighlightIds()
    const successHighlightIds = this.getSuccessHighlightIds()
    const animateIds = this.getAnimateIds()
    const roomProgressData = {
      roomId: 'living-room',
      roomsCleared,
      modalIsActive,
      setGameFinished,
      setModalStatus,
      setRoomsCleared,
      gameFinished,
      setSelectedRoom,
      setStartButtonUrl,
      isOver18,
      openQuizModal,
      clearedQuizRoomIds,
    }
    let buttonText = getRoomButtonText()

    return [
      <StyledTipTracker
        openedTipsCount={this.getOpenedTipsCount()}
        roomName={this.constructor.roomName}
        tipsCount={this.constructor.tipsCount}
        key="living-room__tip-tracker"
        isOver18={isOver18}
        shakasEarned={clearedQuizRoomIds.length}
        colorScheme="green"
      />,
      <StyledFooter
        key="living-room__footer"
        roomName={this.constructor.roomName}
      />,
      <Preload
        items={preloadItems}
        onLoaded={this.onPreloadLoaded.bind(this)}
        key="living-room__preload"
      >
        {(loaded, percentDone) =>
          loaded ? (
            [
              <StyledMobile key="living-room__mobile">
                <LivingRoomRoomMobile
                  animateIds={animateIds}
                  clickedAllItems={this.clickedAllItems()}
                  data={data}
                  onItemClick={this.onItemClick.bind(this)}
                  pendingHighlightIds={pendingHighlightIds}
                  renderTip={this.renderTip.bind(this)}
                  shouldBlock={this.shouldBlock()}
                  successHighlightIds={successHighlightIds}
                  transition={transition}
                  onRoomClear={this.onRoomClear}
                  roomProgressData={roomProgressData}
                  buttonText={buttonText}
                />
              </StyledMobile>,
              <StyledDesktop key="living-room__desktop">
                <LivingRoomRoomDesktop
                  animateIds={animateIds}
                  clickedAllItems={this.clickedAllItems()}
                  data={data}
                  onItemClick={this.onItemClick.bind(this)}
                  pendingHighlightIds={pendingHighlightIds}
                  renderTip={this.renderTip.bind(this)}
                  shouldBlock={this.shouldBlock()}
                  successHighlightIds={successHighlightIds}
                  transition={transition}
                  onRoomClear={this.onRoomClear}
                  roomProgressData={roomProgressData}
                  buttonText={buttonText}
                />
              </StyledDesktop>,
            ]
          ) : (
            <StyledPreloadBar percentDone={percentDone} colorScheme="green" />
          )
        }
      </Preload>,
    ]
  }
}

const LivingRoomPageConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(connectAudio()(withStatechart(statechart)(LivingRoomPage)))

export default LivingRoomPageConnected

export const pageQuery = graphql`
  query allLivingRoomTips {
    allMarkdownRemark(
      filter: {
        frontmatter: { type: { eq: "tip" }, roomId: { eq: "living-room" } }
      }
    ) {
      edges {
        node {
          html
          frontmatter {
            id
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/living-room/index.js